import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from 'src/config/app.config';
import { EventEmitterService } from '../event-emitter.service';
import { NxMessageToastService } from '@aposin/ng-aquila/message';
import { WalletRefreshService }  from './walletbalance-service'
import { ActivatedRoute } from '@angular/router';
import { MESSAGE_CONSTS } from '../ValidationMessages';

@Component({
  selector: 'app-walletbalance',
  templateUrl: './walletbalance.component.html',
  styleUrls: ['./walletbalance.component.css']
})
export class WalletbalanceComponent implements OnInit {

  private _apiUrl;
  userRole: string;
  userId: any;
  walletBalance: number = 0;
  DealerReg: boolean;
  changeDetectorRef: ChangeDetectorRef;
  private _activatedroute: ActivatedRoute | null = null;
  Messages: any;
  walletAlertLevel: string | null = null;
  lowBalanceAlertDto = {};
  walletBalanceReminder: number = 0;


  constructor(
  private authService: AuthService, private appConfig : AppConfig,
  private eventEmitterService: EventEmitterService,
  private messageToastService: NxMessageToastService,
  changeDetectorRef: ChangeDetectorRef,
  private walletRefreshService : WalletRefreshService
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.userRole = atob(localStorage.getItem("userRole") ?? '');
    this.DealerReg = (localStorage.getItem("DealerReg") == 'true' && this.userRole == 'Dealer');
    this.changeDetectorRef = changeDetectorRef;
    this.Messages = MESSAGE_CONSTS;
  }

  ngOnInit() {
    this.walletRefreshService.walletBalanceListner.subscribe(refresh => {
      this.getWalletBalance();
     });
  }

  public getWalletBalance() {

    if (this.userRole == 'WorkShop' || this.DealerReg) {
      this.authService.get(this._apiUrl + '/api/v1/WalletDetails/GetWalletBalance').subscribe(response => {
        if (response.success) {
          this.walletBalance = response.data != 0 ? <number>response.data.toFixed(2) : 0.00;
        }
        else {
          this.messageToastService.open(response.responsemsg, {
            context: "info",
            duration: 5000,
          });
          this.walletBalance = response.data != 0 ? <number>response.data.toFixed(2) : 0.00;
        }

        this.walletBalanceReminder = response.walletBalanceReminder ?? 0;
        this._updateAlertLevel();

        if(this._activatedroute)
        {
          var path = this._activatedroute.snapshot.url[0].path;
          if(path=="sellpolicy" && response.isMinBalance)
          {
            this.messageToastService.open(this.Messages.WALLET_LOW_ON_SELL_POLICY, {
              context: "info",
              duration: 5000,
            });
          }
        }
      }, (error) => {
        console.error(error);
      });
    }
  }

  private _updateAlertLevel() {
    const balance = this.walletBalance;

    if (balance <= this.Messages.WALLET_RED_THRESHOLD) {
      this.walletAlertLevel = 'red';
      this._sendLowBalanceReminderEmail('red');
    } else if (balance <= this.Messages.WALLET_AMBER_THRESHOLD) {
      this.walletAlertLevel = 'amber';
      this._sendLowBalanceReminderEmail('amber');
    } else {
      this.walletAlertLevel = null;
    }
  }

  private _sendLowBalanceReminderEmail(level: 'amber' | 'red') {
    if (level === 'amber' && this.walletBalanceReminder !== 0) return;
    if (level === 'red' && this.walletBalanceReminder === 2) return;

    this.lowBalanceAlertDto = {
      AlertLevel: level,
      WalletBalance: Number(this.walletBalance)
    };
    this.authService.put(
      this._apiUrl + '/api/v1/WalletDetails/SendLowBalanceAlert',
      this.lowBalanceAlertDto
    ).subscribe(
      (response) => {
        if (response?.responsemsg) {
          this.messageToastService.open(response.responsemsg, {
            context: 'info',
            duration: 5000,
          });
        }
      },
      (error) => console.error('Wallet alert email error:', error)
    );
  }

}
